import { datadogRum } from '@datadog/browser-rum';

export const RUM_ACTION_NAME = {
  OPEN_OLD_CREATE_FILE: 'Open old create file',
  BLOCK_ACTIONS_MODAL_OPENED: 'expectUsage',
  DROPDOWN_FILTER_COLUMN_SELECTED: 'selectedColumn',
  DROPDOWN_FILTER_SELECTED: 'selectedFilter',
  NEW_CREATE_FILE: 'newCreateFile',
  DOCUMENT_LIST_VIEW_MODE: 'documentListViewMode',
  BULK_FORCE_CLOSE_FILES: 'bulkyForceCloseFiles',
  LOGIN_LANGUAGE_UNAVAILABLE_FALLBACK: 'loginLanguageUnavailableFallback',
  IFRAME_LOCALE_RESOLUTION: 'iframeLocaleResolution',
  IFRAME_USAGE: 'iframeUsage',
} as const;

export type RumActionName =
  (typeof RUM_ACTION_NAME)[keyof typeof RUM_ACTION_NAME];

export const trackRumAction = (
  name: RumActionName,
  context?: Record<string, unknown>,
): void => {
  datadogRum.addAction(name, context);
};
